<template>
    <div class="row align-items-end">
        <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">Şube</label>
            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tümü"></v-select-list>
        </div>
        <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">Durum</label>
            <v-select-list :options="statuses" label="name" v-model="status" placeholder="Tümü"></v-select-list>
        </div>
        <!-- <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">Güncellik Durumu</label>
            <v-select-list :options="uptodates" label="name" v-model="uptodate" placeholder="Tümü"></v-select-list>
        </div> -->
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filterData)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'

export default {
    data(){
        return{
            branches:[],
            statuses:[
                {name:'Aktif',value:true},
                {name:'Pasif',value:false},
            ],
            uptodates:[
                {name:'Güncel',value:true},
                {name:'Güncel Değil',value:false},
            ],
            filterData:{
                BranchId:null,
                Status:null,
            }
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        clearForm(){
            this.filterData.BranchId = null
            this.filterData.Status = null
            this.filterData.IsUpToDate = null
            this.$emit('filter',this.BranchId)
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
    },
    computed:{
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.filterData.BranchId)
            },
            set:function(value){
                this.filterData.BranchId = value?.Id || null
            }
        },
        status:{
            get:function(){
                return this.statuses.find(b=>b.value==this.filterData.Status)
            },
            set:function(value){
                this.filterData.Status = value?.value != null ? value.value : null
            }
        },
        uptodate:{
            get:function(){
                return this.uptodates.find(b=>b.value==this.filterData.IsUpToDate)
            },
            set:function(value){
                this.filterData.IsUpToDate = value?.value != null ? value.value : null
            }
        },
    }
}
</script>